const checkGenderForProgram = (programGender) => {
  if (programGender === 'Boys') {
    return "Male"
  }

  if (programGender === 'Girls') {
    return "Female"
  }

  if (programGender === 'Both') {
    return 'Both'
  }
}

const checkProgramRegistrationIsDisableByGender = (gender, programGender) => {
  const maleValues = ['boy', 'male']
  const femaleValues = ['girl', 'female']

  if (!gender) {
    return false
  }

  if (programGender === 'Both') {
    return false
  }

  if (programGender === 'Male' && maleValues.indexOf(gender.toLowerCase()) === -1) {
    return true
  }

  if (programGender === 'Female' && femaleValues.indexOf(gender.toLowerCase()) === -1) {
    return true
  }

  return false
}
export {
  checkGenderForProgram,
  checkProgramRegistrationIsDisableByGender,
}
